<template>
  <div>
    <div class="vx-row mt-5">
       <!-- Analista Responsável -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <label for="Analista Responsável Terceiro" class="vs-select--label"
              >Analista Responsável Terceiro</label
            >
            <v-select
              :options="dominios.listResponsaveis"
              v-model="formCadastroTerceiro.idAnalista"
              name="Analista Responsável Terceiro"
              id="Analista Responsável Terceiro"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

          <!-- Regulador Responsável -->
          <div class="vx-col lg:w-1/3 w-full mb-2">
            <label for="Regulador Responsável Terceiro" class="vs-select--label"
              >Regulador Responsável Terceiro</label
            >
            <v-select
              :options="dominios.listResponsaveis"
              v-model="formCadastroTerceiro.idRegulador"
              name="Regulador Responsável Terceiro"
              id="Regulador Responsável Terceiro"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>

        <!-- Sicronizar Eventos Cilia -->
        <div class="vx-col lg:w-1/3 w-full mb-2">
          <label class="vs-input--label">Sincronizar Eventos Cilia</label>
          <vs-switch
            v-model="formCadastroTerceiro.sincronizarCilia"
            color="success"
            class="mt-2 ml-2"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
    </div>

    <div class="vx-row mt-5">
      <!-- Motivos do Evento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Motivo do Sinistro</label>
        <v-select
          class="selectStyle"
          :options="listMotivos"
          name="Motivo do Evento"
          id="Motivo do Evento"
          v-model="formCadastroTerceiro.idMotivoEvento"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>

      <!-- Status do Evento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Status do Sinistro</label>
        <v-select
          class="selectStyle"
          :options="listSituacoes"
          name="Status do Evento"
          id="Status do Evento"
          v-model="formCadastroTerceiro.idStatus"
          label="label"
          :reduce="(item) => item.id"
        ></v-select>
      </div>

      <!-- Envolvimento -->
      <div class="vx-col lg:w-1/4 w-full mb-2">
        <label class="vs-select--label">Envolvimento</label>
        <v-select
          class="selectStyle"
          :options="listEnvolvimentos"
          name="Envolvimento"
          id="Envolvimento"
          v-model="formCadastroTerceiro.idEnvolvimento"
          label="label"
          :reduce="(item) => item.id"
          v-validate="{ required: true }"
        ></v-select>
      </div>

      <!-- Data e Hora Evento -->
      <div class="vx-col lg:w-1/4 w-full lg:flex lg:gap-5 mb-2">
        <!-- Data do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Data Sinistro</label>
          <div class="inputData">
            <flat-pickr
              :config="configDateTimePickerDay"
              v-model="formCadastroTerceiro.dataEvento"
              placeholder="DD/MM/AAAA"
              name="Data do Evento"
            />
          </div>
        </div>

        <!-- Hora do Evento -->
        <div class="xl:w-1/2 w-full">
          <label class="vs-input--label">Hora Sinistro</label>
          <div class="inputData">
            <flat-pickr
              :config="configDateTimePickerHour"
              v-model="formCadastroTerceiro.horaEvento"
              placeholder="HH:MM"
              name="Hora do Evento"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Descrição do Evento para Controle Interno -->
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <vs-textarea
          label="Descrição do Evento para Controle Interno"
          v-model="formCadastroTerceiro.descricaoEventoControleInterno"
        />
      </div>
    </div>

    <!-- Observações -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <span class="vs-input--label">Observações</span>
        <vue-editor
          v-model="formCadastroTerceiro.observacao"
          :editor-toolbar="customToolbar"
        ></vue-editor>
      </div>
    </div>

    <HistoricoObservacao :historicos="formCadastroTerceiro.historicos" />
  </div>
</template>

<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../components/editor/config';

import HistoricoObservacao from './../../shared/components/HistoricoObservacao.vue';

export default {
  props: ['formData', 'dominios'],
  components: { vSelect, flatPickr, HistoricoObservacao, VueEditor },
  watch: {
    formData(value) {
      if (!value.cadastroTerceiro) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO TERCEIRO FORM');
        return;
      }

      this.formCadastroTerceiro = Object.assign(
        this.formCadastroTerceiro,
        value.cadastroTerceiro,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.cadastroTerceiro = this.formCadastroTerceiro;
    },
  },
  data() {
    return {
      showComponent: true,
      formCadastroTerceiro: {
        idAnalista: null,
        idRegulador: null,
        sincronizarCilia: false,
        idMotivoEvento: null,
        idStatus: null,
        idEnvolvimento: null,
        dataEvento: null,
        horaEvento: null,
        dataHoraEvento: null,
        descricaoEventoControleInterno: null,
        observacao: null,
        historicos: [],
      },
      listMotivos: [],
      listSituacoes: [],
      listEnvolvimentos: [],
      listResponsaveis: [],

      // Configurações de Component
      configDateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configDateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
      customToolbar,
    };
  },

  mounted() {
    if (!this.formData.cadastroTerceiro) {
      console.error('ERRO NO CONTRATO DO OBJETO - CADASTRO TERCEIRO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.cadastroTerceiro = this.formCadastroTerceiro;

    this.listMotivos = this.dominios.listMotivos;
    this.listSituacoes = this.dominios.listSituacoes;
    this.listEnvolvimentos = this.dominios.listEnvolvimentos;
    this.listResponsaveis = this.dominios.listResponsaveis;
  },
};
</script>

<style scoped>
.inputData > input {
  width: 100%;
}

.selectStyle {
  font-size: 1rem !important;
}
</style>

<style src="./../../../../../components/editor/style-editor.css"></style>
